import Cookies from 'js-cookie';

import { setAuthToken, axiosAuthInstance } from "@/common/axiosAuthInstance";

const registerUser = async (data: any) => {
    const URL = '/Account/register';

    try {
        const token = Cookies.get('access_token') as string;
        setAuthToken(token);
        return await axiosAuthInstance.post<any[]>(URL, data);
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const getCurrentUser = async (token: string) => {
    const URL = '/Account/user/current';

    try {
        setAuthToken(token);
        return await axiosAuthInstance.get<any[]>(URL);
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

export {
    getCurrentUser,
    registerUser
}
